import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const createTeam = async (teamData, token) => {
  try {
    const payload = {
      name: teamData.name,
      departmentId: teamData.departmentId
    };

    if (teamData.leadId) {
      payload.leadId = teamData.leadId;
    }

    if (teamData.parentId) {
      payload.parentId = teamData.parentId;
    }

    const response = await axios.post(`${BASE_URL}/user/v1/team`, payload, {
      headers: { 
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      }
    });

    const data = response.data.data;
    
    if (!data) {
      throw new Error('No team data received');
    }

    return {
      success: response.data.status === 0,
      team: {
        id: data.id,
        name: data.name,
        departmentId: data.departmentId,
        leadId: data.leadId,
        parentId: data.parentId,
        createdAt: data.createdAt,
        updatedAt: data.updatedAt
      }
    };
  } catch (error) {
    return handleError(error);
  }
};

export const activateTeam = async (teamId, token) => {
  try {
    const response = await axios.post(`${BASE_URL}/user/v1/team/activate`, {
      team_id: teamId
    }, {
      headers: { 
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      }
    });

    return {
      success: response.data.status === 0,
      message: response.data.message
    };
  } catch (error) {
    return handleError(error);
  }
};

export const getTeamById = async (teamId, token) => {
  try {
    const response = await axios.get(`${BASE_URL}/user/v1/team/${teamId}`, {
      headers: { 
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      }
    });

    const data = response.data.data;
    
    if (!data) {
      throw new Error('No team data received');
    }

    return {
      success: response.data.status === 0,
      team: {
        id: data.id,
        name: data.name,
        departmentId: data.department_id,
        leadId: data.leadId,
        parentId: data.parentId,
        createdAt: data.createdAt,
        updatedAt: data.updatedAt
      }
    };
  } catch (error) {
    return handleError(error);
  }
};

export const updateTeam = async (teamData, token) => {
  try {
    const payload = {
      name: teamData.name
    };

    if (teamData.leadId) {
      payload.leadId = teamData.leadId;
    }

    if (teamData.parentId) {
      payload.parentId = teamData.parentId;
    }

    if (teamData.departmentId) {
        payload.departmentId = teamData.departmentId;
    }

    const response = await axios.patch(`${BASE_URL}/user/v1/team/${teamData.id}`, payload, {
      headers: { 
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      }
    });

    const data = response.data.data;
    
    if (!data) {
      throw new Error('No team data received');
    }

    return {
      success: response.data.status === 0,
      team: {
        id: data.id,
        name: data.name,
        departmentId: data.departmentId,
        leadId: data.leadId,
        parentId: data.parentId,
        createdAt: data.createdAt,
        updatedAt: data.updatedAt
      }
    };
  } catch (error) {
    return handleError(error);
  }
};

export const deleteTeam = async (teamId, token) => {
  try {
    const response = await axios.delete(`${BASE_URL}/user/v1/team/${teamId}`, {
      headers: { 
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      }
    });

    return {
      success: response.data.success && response.data.status === 0,
      message: response.data.message
    };
  } catch (error) {
    return handleError(error);
  }
};

export const removeUserFromTeam = async (teamId, userId, token) => {
  try {
    const response = await axios.delete(`${BASE_URL}/user/v1/team/${teamId}/user/${userId}`, {
      headers: { 
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      }
    });

    return {
      success: response.data.status === 0,
      message: response.data.message
    };
  } catch (error) {
    return handleError(error);
  }
};

export const getAllTeams = async (params, token) => {
  try {
    // Create base query parameters
    const queryParams = new URLSearchParams();
    
    if (params.pagination) {
      queryParams.append('pagination.page', params.pagination.page || 1);
      queryParams.append('pagination.page_size', params.pagination.pageSize || 10);
    }
    
    if (params.sorting) {
      queryParams.append('sorting.sort_by', params.sorting.sort_by);
      queryParams.append('sorting.order', params.sorting.order);
    }
    
    if (params.nameFilter) {
      queryParams.append('name_filter', params.nameFilter);
    }
    
    if (params.departmentId) {
      queryParams.append('department_id', params.departmentId);
    }
    
    if (params.leadId) {
      queryParams.append('lead_id', params.leadId);
    }
    
    if (params.parentId) {
      queryParams.append('parent_id', params.parentId);
    }
    
    const url = `${BASE_URL}/user/v1/teams?${queryParams.toString()}`;
    console.log('Team API URL:', url);
    
    const response = await axios.get(url, {
      headers: { 
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      }
    });

    const responseData = response.data;
    console.log('Team API response:', responseData);
    
    if (!responseData.data) {
      throw new Error('No teams data received');
    }

    return {
      success: responseData.status === 0,
      teams: responseData.data.map(team => ({
        id: team.id,
        name: team.name,
        departmentId: team.departmentId,
        leadId: team.leadId,
        parentId: team.parentId,
        createdAt: team.createdAt,
        updatedAt: team.updatedAt
      })),
      pagination: {
        totalCount: responseData.totalCount,
        pageCount: responseData.pageCount,
        page: responseData.page,
        pageSize: responseData.pageSize
      }
    };
  } catch (error) {
    console.error('Team API Error details:', error.response?.data || error.message);
    return handleError(error);
  }
};

const handleError = (error) => {
  console.error('Team API Error:', error);
  
  if (error.response?.status === 503) {
    return {
      success: false,
      error: 'Service temporarily unavailable'
    };
  }
  
  return {
    success: false,
    error: error.response?.data?.message || error.message || 'Operation failed'
  };
}; 